import { Signal } from "signals";
import { IIntegrationWrapper, IWrapperMediator } from "slotworks/integration/revolver/wrapper/wrapper-mediator";
import { InitRecordSchema } from "../revolver/schema/init-record-schema";
import { SpinResponseSchema } from "../revolver/schema/spin-record-schema";
import { WrapperEvent } from "../revolver/wrapper/WrapperEvent";

export class GameiomWrapper implements IIntegrationWrapper, IWrapperMediator {
    public events = new Signal();

    public constructor() {
        if ("gameWrapper" in window) {
            // @ts-ignore
            const wrapper = window.gameWrapper;

            wrapper.pauseGame = () => this.events.dispatch(WrapperEvent.Pause);
            wrapper.resumeGame = () => this.events.dispatch(WrapperEvent.Resume);
        }
    }

    public dispose = () => {
        if ("gameWrapper" in window) {
            // @ts-ignore
            const wrapper = window.gameWrapper;

            wrapper.pauseGame = () => {};
            wrapper.resumeGame = () => {};
        }

        this.events.removeAll();
        this.events = null;
    }

    // IWrapperMediator implementation
    public init = () => {}
    public quit = () => {}
    public gameDataLoaded = (response: InitRecordSchema) => {}
    public gameLoaded = () => {}
    public roundStart = (totalBet: number, balance: number) => {}
    public roundStarted = (spinId: number, balanceBefore: number) => {}
    public spinResponseReceived = (response: SpinResponseSchema) => {}
    public balanceUpdated = (balance: number) => {}
    public reportPaused = () => {}
    public roundEnd = (win: number, bet: number, balance: number) => {}
    public autoplayStart = () => {};
    public autoplayEnd = () => {};
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/integration/gameiom/GameiomWrapper.ts